import React, { useState, useEffect } from "react";
import { SketchPicker } from "react-color";

const MultiColorPicker = ({
  label = "Pick a Color",
  selectedColors = [],
  onChange = () => {},
  errorMsg = "",
  setValue 
}) => {
  const [currentColor, setCurrentColor] = useState("#fff");

  const handleColorChange = (color) => {
    setCurrentColor(color.hex);
  };

  const addColor = () => {
    if (!selectedColors.includes(currentColor)) {
      const newColors = [...selectedColors, currentColor];
      onChange(newColors);
      setValue("selectedColors", newColors, { shouldValidate: true });
    }
  };

  const removeColor = (colorToRemove) => {
    const newColors = selectedColors.filter((color) => color !== colorToRemove);
    onChange(newColors); // Update state in parent
    setValue("selectedColors", newColors, { shouldValidate: true }); // Update form value
  };

  return (
    <div className="md:w-1/2 w-1/3 pl-2">
      <label className="block text-gray-700 font-bold mb-2 dark:text-slate-200">
        {label}
      </label>
      <div>
        <SketchPicker
          color={currentColor}
          onChange={handleColorChange}
          className="mt-3"
        />
        <button
          onClick={addColor}
          className="mt-2 p-2 bg-orange-500 text-white rounded w-28 h-10"
        >
          Add Color
        </button>
      </div>
      <div className="mt-2 flex flex-wrap">
        {selectedColors.map((color, index) => (
          <div key={index} className="m-1 p-2 border rounded flex items-center">
            <div
              style={{ backgroundColor: color }}
              className="w-8 h-8 mr-2"
            ></div>
            <button
              onClick={() => removeColor(color)}
              className="ml-2 text-red-500"
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      {errorMsg && <div className="text-red-500 my-2">{errorMsg}</div>}
    </div>
  );
};

export default MultiColorPicker;
